import React, { useContext } from 'react';
// import { useSnackbar } from 'react-simple-snackbar';
import { useSnackbar } from '../components/Snackbar';
import { ToastContext } from '../contexts/toastContext';

export default function useToast() {
  // const [openSnackbar] = useSnackbar();
  const { showSnackbar: openSnackbar } = useSnackbar();
  const { showToast, hideToast } = useContext(ToastContext);

  const triggerClose = React.useCallback((duration = 5000) => {
    hideToast && setTimeout(hideToast, duration);
  }, [hideToast]);

  const catchErrorToast = React.useCallback((errObj) => {
    if (errObj?.response?.data) {
      openSnackbar(errObj?.response?.data);
    }
  }, [openSnackbar]);

  const successToast = React.useCallback((msg: string) => {
    openSnackbar(msg, { type: 'success' });
  }, [openSnackbar]);

  const errorToast = React.useCallback((msg: string) => {
    openSnackbar(msg, { type: 'error' });
  }, [openSnackbar]);

  const toastSuccess = React.useCallback((message) => {
    showToast?.('success', message);
    triggerClose();
  }, [showToast, triggerClose]);

  const toastError = React.useCallback((message) => {
    showToast?.('error', message);
    triggerClose();
  }, [showToast, triggerClose]);

  return {
    catchErrorToast,
    successToast,
    errorToast,
    toastSuccess,
    hideToast,
    toastError,
  };
}
